// src/app/redux/reducers/niveauSkillReducer.js

import {
    FETCH_NIVEAU_SKILLS_REQUEST, FETCH_NIVEAU_SKILLS_SUCCESS, FETCH_NIVEAU_SKILLS_FAIL,
    CREATE_NIVEAU_SKILL_REQUEST, CREATE_NIVEAU_SKILL_SUCCESS, CREATE_NIVEAU_SKILL_FAIL,
    UPDATE_NIVEAU_SKILL_REQUEST, UPDATE_NIVEAU_SKILL_SUCCESS, UPDATE_NIVEAU_SKILL_FAIL,
    DELETE_NIVEAU_SKILL_REQUEST, DELETE_NIVEAU_SKILL_SUCCESS, DELETE_NIVEAU_SKILL_FAIL,
    SET_NIVEAU_SKILL_LOADING, CLEAR_NIVEAU_SKILL_ERROR,
} from "../actions/niveauSkillActions";

const initialState = {
    niveauSkills: [],
    loading: false,
    error: null,
};

export default function niveauSkillReducer(state = initialState, action) {
    switch (action.type) {

        case SET_NIVEAU_SKILL_LOADING:
            return { ...state, loading: action.payload };

        case CLEAR_NIVEAU_SKILL_ERROR:
            return { ...state, error: null };

        case FETCH_NIVEAU_SKILLS_REQUEST:
        case CREATE_NIVEAU_SKILL_REQUEST:
        case UPDATE_NIVEAU_SKILL_REQUEST:
        case DELETE_NIVEAU_SKILL_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_NIVEAU_SKILLS_SUCCESS:
            return { ...state, loading: false, niveauSkills: action.payload || [] };

        case CREATE_NIVEAU_SKILL_SUCCESS:
            return { ...state, loading: false, niveauSkills: [...state.niveauSkills, action.payload] };

        case UPDATE_NIVEAU_SKILL_SUCCESS:
            return {
                ...state,
                loading: false,
                niveauSkills: state.niveauSkills.map((n) =>
                    n.id === action.payload.id ? action.payload : n
                ),
            };

        case DELETE_NIVEAU_SKILL_SUCCESS:
            return {
                ...state,
                loading: false,
                niveauSkills: state.niveauSkills.filter((n) => n.id !== action.payload.id),
            };

        case FETCH_NIVEAU_SKILLS_FAIL:
        case CREATE_NIVEAU_SKILL_FAIL:
        case UPDATE_NIVEAU_SKILL_FAIL:
        case DELETE_NIVEAU_SKILL_FAIL:
            return { ...state, loading: false, error: action.error || "Erreur" };

        default:
            return state;
    }
}